import { API_URL } from '@api/apiDictionary';
import { RESTClient, RESTClientMock } from '@api/client';
import { USE_API_MOCKS } from '../env';
import {
  fetchClinicalTrialQuestionnairesMock,
  createRandomQuestionnaireItemListMock,
} from '@api/mocks/questionnaire';
import { Questionnaire } from '@dynamika-shared/types/questionnaire';
import {
  AssignClinicalTrialQuestionnairePayload,
  TemplateFormType,
} from '@restore/questionnaires/questionnaires.types';
import { throttle } from 'lodash';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export const fetchQuestionnaireList = throttle(async (name?: string) => {
  if (USE_API_MOCKS) {
    createRandomQuestionnaireItemListMock();
  }
  return api.get<Questionnaire[]>(API_URL.inventoryQuestionnaires, {
    params: { name },
  });
}, 500);

export const fetchClinicalTrialQuestionnaireList = async (
  clinicalTrialId: string
) => {
  if (USE_API_MOCKS) {
    fetchClinicalTrialQuestionnairesMock();
  }
  return api.get<Questionnaire[]>(
    API_URL.clinicalTrialQuestionnaires.replace(':id', clinicalTrialId)
  );
};
export const addClinicalTrialQuestionnaire = async (
  clinicalTrialId: string,
  data: TemplateFormType
) => {
  return api.post<Questionnaire>(
    API_URL.clinicalTrialQuestionnaires.replace(':id', clinicalTrialId),
    data
  );
};
export const deleteClinicalTrialQuestionnaire = async (
  clinicalTrialId: string,
  questionnaireId: string
) => {
  return api.delete(
    API_URL.clinicalTrialQuestionnaires.replace(':id', clinicalTrialId) +
      `/${questionnaireId}`
  );
};
export const assignClinicalTrialQuestionnaireToVisit = async (
  clinicalTrialId: string,
  questionnaire: AssignClinicalTrialQuestionnairePayload
) => {
  return api.post(
    API_URL.clinicalTrialQuestionnairesBinding.replace(':id', clinicalTrialId),
    questionnaire
  );
};
export const unassignClinicalTrialQuestionnaireFromVisit = async (
  clinicalTrialId: string,
  questionnaireId: string
) => {
  return api.delete(
    API_URL.clinicalTrialQuestionnairesUnbinding
      .replace(':id', clinicalTrialId)
      .replace(':questionnaireId', questionnaireId)
  );
};
